import script from "./QuickpaySettingsRightSidebar.vue?vue&type=script&setup=true&lang=ts"
export * from "./QuickpaySettingsRightSidebar.vue?vue&type=script&setup=true&lang=ts"

import "./QuickpaySettingsRightSidebar.vue?vue&type=style&index=0&id=3e0822af&scoped=true&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3e0822af"]])

export default __exports__